import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { IoPersonSharp } from "react-icons/io5";
import api from '../../../services/api';
import axiosPublic from '../../../services/axios/axiosPublic';
import { fetchverifyTokenDetails } from '../../../redux/slice/verifyTokenSlice'
import { useSelector, useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';

export default function EmailVerification() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { token } = useParams();
    const { handleSubmit, formState: { errors }, reset, setValue} = useForm();
    const tokendata = useSelector((state) => state.TokenDetails.TokenDetails)
    const [email, setEmail] = useState(tokendata)
    
    useEffect(() => {
        dispatch(fetchverifyTokenDetails(token));
    }, [dispatch]);

    useEffect(() => {
        setValue("emailForVerification", email);
        setEmail(tokendata)
    }, [tokendata]);

    const handleFormSubmit = async () => {
        try {
            const formData = new URLSearchParams();
            formData.append('email', email);
            const response = await axiosPublic.post(api.sendOtp, formData, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            });
            if (response?.data?.success === true) {
                toast.success(response?.data?.reason || "Otp has been sent to your email!");
                localStorage.setItem('emailForOtpValidation', email);
                setTimeout(() => {
                    navigate('/enter-otp', { replace: true })
                }, 2000);
            } else {
                toast.error(response?.data?.reason || "This email is not registered. Please check again.", { className: 'toast-error-custom', autoClose: 8000 });
            }
            reset({ emailForVerification: '' });
        } catch (err) {
            toast.error(err?.message || "Unable to connect to the server.", { className: 'toast-error-custom', autoClose: 8000 });
        }
    };

    return (
        <div className="container-fluid candidate-authentication">
            <div className='main-logo'>
                <div className="logo-image">
                    <img src={require("assets/img/company_logo.png")} alt="..." />
                </div>
            </div>
            <div className="login-container">
                <div className="login-row">
                    <div className="col-lg-12 col-md-10 col-sm-8 col-xs-12 left">
                        <div className="login-form">
                            <div className="title" style={{ marginBottom: '10px' }}>
                                <p className="welcome" style={{ marginBottom: '3px' }}>Verify your email address</p>
                                <p style={{ color: '#5A5A5A', fontSize: '14px', marginTop: "0" }}>You must verify your email address to access the otp page</p>
                            </div>
                            <div className="form">
                                <form onSubmit={handleSubmit(handleFormSubmit)}>
                                    <div className="form-detail">
                                        <div className={`input-text ${errors.emailForVerification ? 'error' : ''}`}>
                                            <div className="input-icons">
                                                <IoPersonSharp className="icon" />
                                                <input value={email} readOnly className="login-input-field" type="email" placeholder="Enter email id" disabled/>
                                                {/* <div className="login-input-field">{email}</div> */}
                                                {errors.emailForVerification && (
                                                    <p className="error-message">{errors.emailForVerification.message}</p>
                                                )}
                                            </div>
                                        </div>
                                        <div>
                                            <button className="login" type='submit'>
                                                Verify your email
                                            </button>
                                        </div>
                                        <br />
                                        <br />
                                        <ToastContainer />
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
